<template>
    <div>
      <canvas 
        ref="summaryChart"
        style="height: 350px;"
      ></canvas>
    </div>
  </template>
  
  <script>
  import Chart from "chart.js";
  
  export default {
    name: "B2cFinanceIncomeExpancesSummaryChart",
    props: {
      groupedData: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        chart: null,
      };
    },
    watch: {
      groupedData: {
        handler() {
          this.renderChart();
        },
        immediate: false,
        deep: true,
      },
    },
    methods: {
      renderChart() {
        if (this.chart) {
          this.chart.destroy(); // Destroy the existing chart to avoid duplicates
        }
  
        const labels = this.groupedData.map((item) => item.external_company);
        const incomeData = this.groupedData.map((item) => item.income);
        const expensesData = this.groupedData.map((item) => item.expenses);
        const differenceData = this.groupedData.map((item) => item.difference);
  
        this.chart = new Chart(this.$refs.summaryChart, {
          type: "bar",
          data: {
            labels: labels,
            datasets: [
              {
                label: "Доходы",
                backgroundColor: "#0D6247",
                data: incomeData,
                barThickness: 25,
              },
              {
                label: "Расходы",
                backgroundColor: "#EA7B27",
                data: expensesData,
                barThickness: 25,
              },
              {
                label: "Разница",
                backgroundColor: "#cacaca",
                data: differenceData,
                barThickness: 25,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              xAxes: [
                {
                  stacked: false,
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    autoSkip: false,
                    maxRotation: 45,
                    minRotation: 0,
                  },
                },
              ],
              yAxes: [
                {
                  stacked: false,
                  ticks: {
                    beginAtZero: true,
                    callback: (value) =>
                      new Intl.NumberFormat("ru-RU", {
                        style: "currency",
                        currency: "RUB",
                      }).format(value),
                  },
                },
              ],
            },
            legend: {
              display: true, // Show legend under the chart
              position: "bottom",
            },
            tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  return new Intl.NumberFormat("ru-RU", {
                    style: "currency",
                    currency: "RUB",
                  }).format(tooltipItem.yLabel);
                },
              },
            },
          },
        });
      },
    },
    mounted() {
      this.renderChart();
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.destroy();
      }
    },
  };
  </script>
  
  <style scoped>
    canvas {
        width: 100%;
        height: 350px;
    }
  </style>
  